import { api } from "@/redux/api";

import {
	CompanyBalance,
	CompanyBalanceArraySchema,
	CreateCompanyBalance,
} from "../../pages/ManageCompanyBalance/schema/company-balance";

export const CompanyBalanceApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getCompanyBalances: builder.query<CompanyBalance[], void>({
			query: () => ({
				url: "company-balance",
				responseSchema: CompanyBalanceArraySchema,
			}),
			providesTags: ["CompanyBalance"],
		}),
		createCompanyBalance: builder.mutation<CompanyBalance, CreateCompanyBalance>({
			query: (body) => ({
				url: "company-balance",
				method: "POST",
				body,
			}),
			invalidatesTags: ["CompanyBalance"],
		}),
		updateCompanyBalance: builder.mutation<CompanyBalance, CompanyBalance>({
			query: (body) => ({
				url: `company-balance/${body.id}`,
				method: "PATCH",
				body,
			}),
			invalidatesTags: ["CompanyBalance"],
		}),
		deleteCompanyBalance: builder.mutation<CompanyBalance[], number>({
			query: (id) => ({
				url: `company-balance/${id}`,
				method: "DELETE",
				responseSchema: CompanyBalanceArraySchema,
			}),
			invalidatesTags: ["CompanyBalance"],
		}),
	}),
});

export const {
	useGetCompanyBalancesQuery,
	useCreateCompanyBalanceMutation,
	useUpdateCompanyBalanceMutation,
	useDeleteCompanyBalanceMutation,
} = CompanyBalanceApi;

export const CompanyBalanceApiReducer = CompanyBalanceApi.reducer;
export const CompanyBalanceApiMiddleware = CompanyBalanceApi.middleware;
